export type TextStoredFile = {
  id: string;
  type: 'TextStoredFile';
  url: string;
  basicText?: string;
};
